export const version = require('../../package.json').version;

export const environment = {
  production: true,
  monthNames:[ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],

  pipeline:{
    pipelineDashboard_URL: 'https://uat.scs.gway.shipco.com/ngLinq/PipelineDashboard',
    pipelineDashboardSecurity_URL: 'https://uat.scs.gway.shipco.com/ngLinq/RetrieveToken', //'https://staging.scs.gway.shipco.com/ngLinq/RetrieveToken',
    systemId: "EC1BCCC3-CBD2-4175-AEB7-9DFEFE0AAAA8",
    pipelineStageTypeIds: {
      Prospect: "374ad492-9a28-4073-91c4-f3d0d4566836",
      InitialContactMade: "d5cda9c3-af6a-4d21-9ad1-1dce09f67c50",
      Met: "88ff67ed-e8e6-4ffa-a3e9-347ed97785eb",
      ProposalSent: "e0d334fc-428f-4767-8e2b-11aed602fdd9",
      Closed_Won: "12c93dc0-4e26-4cfa-b9b1-36cb31b5dff4",
      Closed_Lost: "ace4526d-e860-413c-866e-b12c19149a8d",
    }
  },

  lookupLists:{
    pipelineLookup_URL: 'https://uat.scs.gway.shipco.com/ngLinq/PipelineDashboardLookup',
    pipelineLookup_actions: {
      PipelineWeekNumbers: "PipelineWeekNumbers",
      PipelineCountries: "PipelineCountries",
      PipelineOffices: "PipelineOffices",
      PipelineConsultants: "PipelineConsultants",
    }
  },
};
